module.exports = __webpack_public_path__ + "static/we-learn-nothing-dc71ff2cd8d2683648a31ebfc7df9028.jpg";